//packages blocks
import OtpInput from "react-otp-input";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import React, { useState, useEffect, useReducer } from "react";
//common blocks
import "./forgot.css";
import Checkbox from "../../components/checkbox";
import { FormButton, FormInput } from "../../components/form";
//styles, utils, assets and api blocks
import { BLACK, BLUE_EIGHT, GREY_SEVENTEEN, WHITE } from "../../theme";
import { setAlert } from "../../redux/reducers/alert";
import logo from "../../assets/images/logo-v1.png";
import { validateForgotPassword } from "../../util/validation";
import { forgotPassword, resendOtp, updateForgotPassword, verifyOtp } from "../../api/auth";
import { BackButton } from "../../components/backButton";
import ReCAPTCHA from "react-google-recaptcha";

const ForgotPassword = () => {
  const [recaptchaResponse, setRecaptchaResponse] = useState('');
  const [isEnglish, setIsEnglish] = useState(true);
  const [isArabic, setIsArabic] = useState(false);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [checkedOne, setCheckedOne] = useState(false);
  const [checkedTwo, setCheckedTwo] = useState(false);
  const [checkedThree, setCheckedThree] = useState(false);
  const [otp, setOtp] = useState("");
  const [showTimer, setShowTimer] = useState(true);
  const [seconds, setSeconds] = useState(60);
  const [timerValue, setTimerValue] = useState(
    `Try it after ${seconds} seconds`
  );
  const { t, i18n } = useTranslation();
  const [{ email, password, emailError, passwordError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      email: "",
      password: "",
      passwordError: false,
      emailError: false,
    }
  );
  const [userInfo, setUserInfo] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    let interval;
    if (showTimer) {
      setTimeout(() => {
        setShowTimer(false);
      }, 60000);
      interval = setInterval(() => {
        if (seconds === 0) {
          clearInterval(interval);
        }
        setSeconds((seconds) => seconds - 1);
        setTimerValue(`Try it after ${seconds} seconds`);
        setSeconds(seconds - 1);
      }, 1000);
    } else {
      setSeconds(60);
      setTimerValue(`Try it after ${60} seconds`);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [showTimer, seconds]);

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  let count;

  const forgotStep1 = async () => {
    const validation = checkedOne && validateForgotPassword(email);
    if (validation !== undefined) {
      if (!validation.status) {
        setData({ [validation?.type]: true });
        showErrorAlert(validation?.message);
        return;
      }
    }
    try {
      setLoading(true);
      const payload = {
        email: email,
        rcResponse: recaptchaResponse
      };
      const response = await forgotPassword(payload);
      if (response.status) {
        setUserInfo(response?.user);
        count = step + 1;
        setStep(count);
        setLoading(false);
      } else {
        setLoading(false);
        showErrorAlert(response?.message);
      }
    } catch (error) {
      showErrorAlert(`The Error is ${error}`);
    }
  };

  const handleChange = (prop) => (event) => {
    setData({
      [prop]: event.target.value,
      emailError: false,
    });
  };

  const otpInputStyle = {
    height: 55,
    width: 55,
    fontSize: 25,
  };

  const otpInputFocus = {
    background: "rgb(30,173,219)",
    color: "white",
  };

  const onOtpChange = (e) => {
    setOtp(e);
  };

  const forgotStep2 = async () => {
    const payload = {
      otp: otp,
      phone: userInfo?.phone,
    };
    try {
      setLoading(true);
      const response = checkedTwo && await verifyOtp(payload);
      if (response.type == "success") {
        showSuccessAlert(response?.message);
        setLoading(false);
        count = step + 1;
        setStep(count);
      } else {
        showErrorAlert(response?.message);
        setLoading(false);
      }
    } catch (error) {
      showErrorAlert(`The error is ${error}`);
    }
  };

  const forgotStep3 = async () => {
    try {
      const payload = {
        phone: userInfo.phone,
      };
      const response = checkedThree && await resendOtp(payload);
      if (response.type == "success") {
        showSuccessAlert(response?.message);
      } else {
        showErrorAlert(response?.message);
      }
      if (response.type == "error") {
        setTimerValue(response?.message);
        setShowTimer(true);
      } else {
        setTimerValue(`Try it after ${seconds} seconds`);
        setShowTimer(true);
      }
    } catch (error) {
      showErrorAlert(`the error is ${error}`);
    }
  };

  const forgotStep4 = async () => {
    const validation = validateForgotPassword(email, password);
    if (validation !== undefined) {
      if (!validation?.status) {
        setData({ [validation?.type]: true });
        showErrorAlert(validation?.message);
        return;
      }
    }
    try {
      setLoading(true);
      const payload = {
        password: password,
        id: userInfo.id,
      };
      const response = await updateForgotPassword(payload, userInfo.token);
      if (response.status) {
        showSuccessAlert(response?.message);
        setLoading(false);
        history.push("/");
      }
    } catch (error) {
      showErrorAlert(`The Error is ${error}`);
    }
  };

  const updateOne = () => setCheckedOne(!checkedOne);
  const updateTwo = () => setCheckedTwo(!checkedTwo);
  const updateThree = () => setCheckedThree(!checkedThree);

  const changeLanguage = (lng) => {
    if (lng === "en") {
      setIsEnglish(true)
      setIsArabic(false)
    } else {
      setIsArabic(true)
      setIsEnglish(false)
    }

    i18n.changeLanguage(lng);
  };

  const onChange = (value) => {
    setRecaptchaResponse(value)
  }

  return (
    <>
      <div style={{ position: 'absolute', padding: 20 }}>
        <BackButton />
      </div>
      {step == "1" ? (
        <div className="forgot-page">
          <div className="forgotForm">
            <div className="payNest_logo_forgot">
              <img className="logo" src={logo} />
            </div>
            <div className="forgot-form-group">
              <Box>
                <Typography variant="h3" style={{ marginBottom: 10, color: BLACK, fontWeight: 900, fontSize: "1.18vw", marginLeft: 8 }}>
                  {t("text_forgot_password")}
                </Typography>
                <Typography variant="body2" style={{ marginLeft: 8, fontSize: "0.8vw" }}>
                  {t("text_please_enter_your_registered_email_id_To_reset_password")}
                </Typography>
              </Box>
              <div className="forgot-form-input">
                <FormInput
                  error={emailError}
                  value={email}
                  onChange={handleChange}
                  label={t("text_email_address")}
                  name="email"
                />
              </div>

              <ReCAPTCHA
                sitekey="6LewaIolAAAAALBLWdo7GV-nSmoj6dyElU7c_VdH"
                onChange={onChange}
              />

              <Box style={{
                display: 'flex',
                justifyContent: 'center'
              }}>
                <Checkbox
                  style={{ textDecoration: "underline", fontSize: "0.73vw", fontFamily: "Montserrat, sans-serif", fontWeight: 600 }}
                  name="a"
                  label={t("text_i_accept_terms_and_conditions")}
                  checked={checkedOne}
                  onChange={updateOne}
                >
                </Checkbox>
              </Box>

              <div style={{ marginTop: 20 }}>
                <FormButton
                  overRideButtonCheck={true}
                  disabled={recaptchaResponse.length > 0 ? false : true}
                  height={60}
                  title={t("text_continue")}
                  backgroundColor={BLUE_EIGHT}
                  titleColor={WHITE}
                  hoverTitleColor={BLUE_EIGHT}
                  hoverBackgroundColor={WHITE}
                  hoverBorderColor={BLUE_EIGHT}
                  loading={loading}
                  borderTopLeftRadius={15}
                  borderTopRightRadius={15}
                  borderBottomRightRadius={15}
                  borderBottomLeftRadius={15}
                  onClickHandler={forgotStep1}
                  skipRoleCheck={true}
                  style={{ fontSize: "0.9vw", fontWeight: "700", textTransform: 'capitalize' }}
                />
              </div>

              <Box display="flex" justifyContent="center" mt={4} mb={2}>
                <Typography variant="h3" style={{ color: isEnglish ? BLACK : GREY_SEVENTEEN, cursor: "pointer", borderRight: `2px solid ${BLUE_EIGHT}`, paddingRight: 5 }} onClick={() => changeLanguage("en")}>
                  {t("text_english")}
                </Typography>

                <Typography variant="h3" style={{ color: isArabic ? BLACK : GREY_SEVENTEEN, cursor: "pointer", marginLeft: 5 }} onClick={() => changeLanguage("ar")}>
                  {t("text_arabic")}
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {step == "2" ? (
        <div className="forgot-page">
          <div className="forgotForm">
            <div className="payNest_logo_forgot">
              <img className="logo" src={logo} />
            </div>
            <div className="forgot-form-group">
              <Box>
                <Typography variant="h3" style={{ marginBottom: 10, color: BLACK, fontWeight: 900, fontSize: "1.18vw", marginLeft: 8 }}>
                  {t("text_forgot_password_simple")}
                </Typography>
                <Typography variant="body2" style={{ marginLeft: 8, fontSize: "0.8vw" }}>
                  {t("text_please_enter_verification_code_from_your_phone_or_email")}
                </Typography>
              </Box>
              <div className="otp-form-group">
                <div className="forgot-form-input">
                  <OtpInput
                    value={otp}
                    numInputs={4}
                    separator={<div style={{ width: 10 }}></div>}
                    inputStyle={otpInputStyle}
                    focusStyle={otpInputFocus}
                    isInputNum={true}
                    onChange={onOtpChange}
                  />
                </div>
              </div>
              <div
                style={{
                  float: "right",
                }}
                className="m-0 reset-otp"
              >
                {showTimer ? (
                  <p className="m-0 mr-4" style={{ cursor: "text" }}>
                    {timerValue}
                  </p>
                ) : (
                  <p className="m-0 mr-4" onClick={forgotStep3}>
                    {t("text_resend_otp")}
                  </p>
                )}
              </div>

              <Box style={{
                display: 'flex',
                justifyContent: 'center'
              }}>
                <Checkbox
                  style={{ textDecoration: "underline", fontSize: "0.73vw", fontFamily: "Montserrat, sans-serif", fontWeight: 600 }}
                  name="a"
                  label={t("text_i_accept_terms_and_conditions")}
                  checked={checkedTwo}
                  onChange={updateTwo}
                >
                </Checkbox>
              </Box>

              <div style={{ marginTop: 20 }}>
                <FormButton
                  height={60}
                  title={t("text_continue")}
                  backgroundColor={BLUE_EIGHT}
                  titleColor={WHITE}
                  hoverTitleColor={BLUE_EIGHT}
                  hoverBackgroundColor={WHITE}
                  hoverBorderColor={BLUE_EIGHT}
                  loading={loading}
                  borderTopLeftRadius={15}
                  borderTopRightRadius={15}
                  borderBottomRightRadius={15}
                  borderBottomLeftRadius={15}
                  skipRoleCheck={true}
                  onClickHandler={forgotStep2}
                  overRideButtonCheck={otp.length < 4}
                  style={{ fontSize: "0.9vw", fontWeight: "700", textTransform: 'capitalize' }}
                />
              </div>

              <Box display="flex" justifyContent="center" mt={4} mb={2}>
                <Typography variant="h3" style={{ color: isEnglish ? BLACK : GREY_SEVENTEEN, cursor: "pointer", borderRight: `2px solid ${BLUE_EIGHT}`, paddingRight: 5 }} onClick={() => changeLanguage("en")}>
                  {t("text_english")}
                </Typography>

                <Typography variant="h3" style={{ color: isArabic ? BLACK : GREY_SEVENTEEN, cursor: "pointer", marginLeft: 5 }} onClick={() => changeLanguage("ar")}>
                  {t("text_arabic")}
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {step == "3" ? (
        <div className="forgot-page">
          <div className="forgotForm">
            <div className="payNest_logo_forgot">
              <img className="logo" src={logo} />
            </div>
            <div className="forgot-form-group">
              <Box>
                <Typography variant="h3" style={{ marginBottom: 10, color: BLACK, fontWeight: 900, fontSize: "1.18vw", marginLeft: 8 }}>
                  {t("text_change_password")}
                </Typography>
                <Typography variant="body2" style={{ marginLeft: 8, fontSize: "0.8vw" }}>
                  {t("text_please_enter_new_password")}
                </Typography>
              </Box>
              <div className="forgot-form-input">
                <FormInput
                  value={password}
                  error={passwordError}
                  onChange={handleChange}
                  label={t("text_password")}
                  name="password"
                />
              </div>

              <Box style={{
                display: 'flex',
                justifyContent: 'center'
              }}>
                <Checkbox
                  style={{ textDecoration: "underline", fontSize: "0.73vw", fontFamily: "Montserrat, sans-serif", fontWeight: 600 }}
                  name="a"
                  label={t("text_i_accept_terms_and_conditions")}
                  checked={checkedThree}
                  onChange={updateThree}
                >
                </Checkbox>
              </Box>

              <div style={{ marginTop: 20, marginLeft: 9, display: "flex", justifyContent: "center" }}>
                <FormButton
                  height={60}
                  title={t("text_continue")}
                  backgroundColor={BLUE_EIGHT}
                  titleColor={WHITE}
                  hoverTitleColor={BLUE_EIGHT}
                  hoverBackgroundColor={WHITE}
                  hoverBorderColor={BLUE_EIGHT}
                  loading={loading}
                  width={295}
                  borderTopLeftRadius={15}
                  borderTopRightRadius={15}
                  borderBottomRightRadius={15}
                  borderBottomLeftRadius={15}
                  style={{ fontSize: "0.9vw", fontWeight: "700", textTransform: 'capitalize' }}
                  skipRoleCheck={true}
                  onClickHandler={forgotStep4}
                />
              </div>

              <Box display="flex" justifyContent="center" mt={4} mb={2}>
                <Typography variant="h3" style={{ color: isEnglish ? BLACK : GREY_SEVENTEEN, cursor: "pointer", borderRight: `2px solid ${BLUE_EIGHT}`, paddingRight: 5 }} onClick={() => changeLanguage("en")}>
                  {t("text_english")}
                </Typography>

                <Typography variant="h3" style={{ color: isArabic ? BLACK : GREY_SEVENTEEN, cursor: "pointer", marginLeft: 5 }} onClick={() => changeLanguage("ar")}>
                  {t("text_arabic")}
                </Typography>
              </Box>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ForgotPassword;
